import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import CursusDetailHero from "@/components/cursus/detail/CursusDetailHero";
import CursusPersonas from "@/components/cursus/detail/CursusPersonas";
import CursusCompetencies from "@/components/cursus/detail/CursusCompetencies";
import MethodeTrilogy from "@/components/MethodeTrilogy";
import CursusParcours from "@/components/cursus/detail/CursusParcours";
import CursusFormateurs from "@/components/cursus/detail/CursusFormateurs";
import CursusSessions from "@/components/cursus/detail/CursusSessions";
import CursusInvestment from "@/components/cursus/detail/CursusInvestment";
import CursusFAQ from "@/components/cursus/detail/CursusFAQ";
import CursusDetailFinalCTA from "@/components/cursus/detail/CursusDetailFinalCTA";
import CursusSeo from "@/components/cursus/detail/CursusSeo";
import { CURSUS_SEO } from "@/lib/cursusMeta";

const KNOWN_SLUGS = Object.keys(CURSUS_SEO);

export default function CursusDetailPage() {
    const { slug } = useParams();
    const [cursus, setCursus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        setNotFound(false);
        api.get(`/cursus/${slug}`)
            .then((r) => mounted && setCursus(r.data))
            .catch((err) => {
                if (!mounted) return;
                if (err?.response?.status === 404) setNotFound(true);
            })
            .finally(() => mounted && setLoading(false));
        return () => { mounted = false; };
    }, [slug]);

    // Scroll to top when slug changes
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [slug]);

    if (!KNOWN_SLUGS.includes(slug) && !loading && notFound) {
        return <Navigate to="/expertise-pa" replace />;
    }

    if (loading) {
        return (
            <div
                className="flex min-h-screen items-center justify-center bg-brand-ink text-white"
                data-testid="cursus-detail-loading"
            >
                <div className="font-display text-lg text-white/60">Chargement…</div>
            </div>
        );
    }

    if (notFound || !cursus) {
        return <Navigate to="/expertise-pa" replace />;
    }

    const formations = cursus.formations || [];

    return (
        <div data-testid="page-cursus-detail" className="bg-white">
            <CursusSeo cursus={cursus} formations={formations} />
            <CursusDetailHero cursus={cursus} />
            <CursusPersonas slug={cursus.slug} />
            <CursusCompetencies slug={cursus.slug} />
            <MethodeTrilogy variant="full" theme="light" />
            <CursusParcours formations={formations} />
            <CursusFormateurs slug={cursus.slug} />
            <CursusSessions slug={cursus.slug} cursusName={cursus.name} formations={formations} />
            <CursusInvestment cursus={cursus} />
            <CursusFAQ slug={cursus.slug} />
            <CursusDetailFinalCTA cursus={cursus} />
        </div>
    );
}
